import { render, staticRenderFns } from "./match-label-popup.vue?vue&type=template&id=75e04002&scoped=true"
import script from "./match-label-popup.vue?vue&type=script&lang=js"
export * from "./match-label-popup.vue?vue&type=script&lang=js"
import style0 from "./match-label-popup.vue?vue&type=style&index=0&id=75e04002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e04002",
  null
  
)

export default component.exports